import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig, fetchAndActivate, getValue, getAll } from "firebase/remote-config";
import { initializeAppCheck, ReCaptchaEnterpriseProvider, getToken } from "firebase/app-check";

import { aesEncryption } from "./networking/security";
import StatesRegion from "./assets/json/state-region.json";

let getBlacklistedWords = [
    "crypto",
    "cryptocurrency",
    "bitcoin",
    "bundle",
    "buycoins",
    "quidax",
    "binance",
    "eth",
    "ether",
    "ethereum",
    "btc",
    "xrp",
    "ripple",
    "tron",
    "trx",
    "doge",
    "dogecoin",
    "bnb",
    "bch",
    "satoshi",
    "usdc",
    "usdt",
    "tether",
    "busd",
    "dai",
    "LTC",
    "litecoin",
    "busha",
    "blockchain",
];

// axios.defaults.headers.common["Authorization"] = `Bearer ${aesDecryption(
//   `${Cookies.get("kudaAppToken")}`,
//   `${process.env.REACT_APP_ENCRYPTION_KEY}`
// )}`;

// axios.defaults.timeout = 12000;

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
    apiKey: `${process.env.REACT_APP_FIREBASE_KEY}`,
    authDomain: "kudabank-ad4eb.firebaseapp.com",
    databaseURL: `${process.env.REACT_APP_FIREBASE_URL}`,
    projectId: "kudabank-ad4eb",
    storageBucket: "kudabank-ad4eb.appspot.com",
    messagingSenderId: "387250825762",
    appId: "1:387250825762:web:9fcc1438e0f37bacef787b",
    measurementId: "G-YZSRXEK6J4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(`${process.env.REACT_APP_FIREBASE_CHECK_KEY}`),
    // Optional argument. If true, the SDK automatically refreshes App Check
    // tokens as needed.
    isTokenAutoRefreshEnabled: true,
});

export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

const getAppCheckToken = async (appCheck) => {
    await getToken(appCheck)
        .then((e) => e)
        .catch((error) => {});
};

getAppCheckToken(appCheck);

let getFaq = [];
let getTC = [];
let getAllConfig = [];
let allBillers = [];
let getControlLive = "";
let getOverdraftTerms = "";
let getCardlessStatus = "";
let getVCardStatus = "";
let getLocations = StatesRegion;
let cardLimits = [];
let cardsPickUpAddress = [];
let cardsConfig = {};
let k4bFeatureConfig = {};
let tokened_bills = {};
let legalSearchFee = 0;
let kuda_business_regFee = {};
let account_upgrade_config = {};
let global_airtime_billers = [];
let business_perks = [];
let cardTermsAndCondition = "";

fetchAndActivate(remoteConfig)
    .then(() => {
        getFaq = JSON.parse(getValue(remoteConfig, "business_faq_json")._value);
        localStorage.setItem("kudaFaqs", JSON.stringify(getFaq));

        getTC = getValue(remoteConfig, "business_tc_json")._value;
        localStorage.setItem("kudaTerms", JSON.stringify(getTC));

        global_airtime_billers = JSON.parse(
            getValue(remoteConfig, process.env.REACT_APP_AIRTIME_KEY)._value,
        );
        localStorage.setItem("global_airtime_billers", JSON.stringify(global_airtime_billers));

        let getBanks = JSON.parse(
            getValue(remoteConfig, `${process.env.REACT_APP_BANKLIST_KEY}`)._value,
        );

        localStorage.setItem(
            "kudaBanks",
            aesEncryption(`${JSON.stringify(getBanks)}`, `${process.env.REACT_APP_ENCRYPTION_KEY}`),
        );

        localStorage.setItem(
            "kudaElectricityBillers",
            allBillers[0] ? JSON.stringify(allBillers[0].billers) : JSON.stringify([]),
        );
        localStorage.setItem(
            "kudaInternetBillers",
            allBillers[2] ? JSON.stringify(allBillers[2].billers) : JSON.stringify([]),
        );
        localStorage.setItem(
            "kudaBettingBillers",
            allBillers[4] ? JSON.stringify(allBillers[4].billers) : JSON.stringify([]),
        );
        localStorage.setItem(
            "kudaTransportBillers",
            allBillers[5] ? JSON.stringify(allBillers[5].billers) : JSON.stringify([]),
        );
        localStorage.setItem(
            "kudaEducationBillers",
            allBillers[6] ? JSON.stringify(allBillers[6].billers) : JSON.stringify([]),
        );

        getAllConfig = getAll(remoteConfig);

        cardsPickUpAddress = JSON.parse(
            getValue(remoteConfig, "kuda_cards_pick_up_locations")._value,
        );
        localStorage.setItem("kudaCardsPickUpAddress", JSON.stringify(cardsPickUpAddress));

        cardsConfig = JSON.parse(getValue(remoteConfig, "cards_config_business")._value);

        cardLimits = JSON.parse(getValue(remoteConfig, "card_limits")._value);
        localStorage.setItem("kudaCardLimits", JSON.stringify(cardLimits));

        cardTermsAndCondition = JSON.parse(getValue(remoteConfig, "business_card_tc_json")._value);
        localStorage.setItem("kudaCardsTermsAndCondition", JSON.stringify(cardTermsAndCondition));

        /* Getting the `kudabusiness_feature_config` from the firebase remote config and storing it in
       the local storage. */
        k4bFeatureConfig = JSON.parse(
            getValue(remoteConfig, `${process.env.REACT_APP_K4B_FEATURE_KEY}`)._value,
        );
        localStorage.setItem("k4bFeatureConfig", JSON.stringify(k4bFeatureConfig));

        legalSearchFee = JSON.parse(getValue(remoteConfig, "legal_search_fee")._value);
        localStorage.setItem("legalSearchFee", JSON.stringify(legalSearchFee));

        /* Getting the `kuda_business_regFee` from the firebase remote config and storing it in
       the local storage. */
        kuda_business_regFee = JSON.parse(getValue(remoteConfig, "kuda_business_regFee")._value);
        localStorage.setItem("kuda_business_regFee", JSON.stringify(kuda_business_regFee));

        /* Account Upgrade Config */
        account_upgrade_config = JSON.parse(
            getValue(remoteConfig, "account_upgrade_config")._value,
        );
        localStorage.setItem("account_upgrade_config", JSON.stringify(account_upgrade_config));

        tokened_bills = JSON.parse(getValue(remoteConfig, "tokened_bills")._value);
        localStorage.setItem("tokened_bills", JSON.stringify(tokened_bills));

        business_perks = getValue(remoteConfig, "business_perks")._value;
        localStorage.setItem("business_perks", business_perks);
    })
    .catch((err) => {
        console.error(err);
    });

export const faq = () => {
    // GET FAQS FROM FIREBASE
    return getFaq;
};

export const tc = () => {
    // GET TERMS AND CONDITIONS FROM FIREBASE
    return getTC;
};

export const overdraftTerms = () => {
    // GET TERMS AND CONDITIONS FROM FIREBASE
    return getOverdraftTerms;
};

export const allConfig = () => {
    return getAllConfig;
};

export const bvnControl = () => {
    return getControlLive;
};

export const cardlessStatus = () => {
    return getCardlessStatus;
};

export const vCardStatus = () => {
    return getVCardStatus;
};

export const getBlacklistedStatus = () => {
    return getBlacklistedWords;
};

export const getPickupLocations = () => {
    return getLocations;
};

export const getCardsPickUpAddress = () => {
    return cardsPickUpAddress;
};

export const getCardsConfig = () => {
    return cardsConfig;
};

export const getCardLimits = () => {
    return cardLimits;
};
export const getTokenedBills = () => {
    return tokened_bills;
};

/**
 * It returns the `k4bFeatureConfig` object
 * @returns The k4bFeatureConfig object.
 */
export const getK4bFeatureConfig = () => {
    return k4bFeatureConfig;
};

export const getBusinessPerks = () => {
    return business_perks;
};
